define(['angular', '../module'], function(angular, MODULE_NAME) {
    'use strict';

    var SERVICE_NAME = 'ilmnUiCookieUtil';

    angular.module(MODULE_NAME)
        .provider(SERVICE_NAME, CookieUtil);

    function CookieUtil() {

    }
    CookieUtil.prototype = {
        $get: ['$cookies', function($cookies) {
            return $cookies;
        }],
        get : function (cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length,c.length);
                }
            }
            return "";
        },

        set: function (cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+d.toUTCString();
            document.cookie = cname + "=" + cvalue + "; " + expires;
        }
    };

    return SERVICE_NAME;
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-utils/scripts/cookie.provider.js
// module id = 21
// module chunks = 0